module.exports = __webpack_public_path__ + "static/media/LVS_01.1bc65e7a.jpeg";